/**
 * Escapes Lucene query_string reserved characters so user input is matched
 * literally (e.g. a "-" or ":" in a name doesn't change the query). `< >`
 * cannot be escaped in Lucene, so they are stripped.
 *
 * Always apply this to the user-typed portion *before* appending intentional
 * syntax such as a trailing `*`, otherwise the wildcard gets escaped too.
 */
export const escapeQueryStringValue = (value: string): string =>
  value.replace(/[<>]/g, '').replace(/[+\-=&|!(){}[\]^"~*?:\\/]/g, '\\$&');

export default escapeQueryStringValue;
